import { writeContract, readContract } from "@wagmi/core";
import { config } from "../App";
import {
  ContarctABI,
  ContractAddress,
  TokenABI,
  TokenAddress,
} from "../utils/Config";
const admin = process.env.REACT_APP_ADMIN_WALLET;
const contractConfig = {
  address: ContractAddress,
  abi: ContarctABI,
};

const TokenConfig = {
  address: TokenAddress,
  abi: TokenABI,
};

const useReadContractMethods = {
  blockAiAddress: () =>
    readContract(config, {
      ...contractConfig,
      functionName: "BLOCKAI",
      args: [],
    }),
  usdtAddress: () =>
    readContract(config, {
      ...contractConfig,
      functionName: "USDT",
      args: [],
    }),
  isUserExist: (address) =>
    readContract(config, {
      ...contractConfig,
      functionName: "isUserExists",
      args: [address],
    }),
  idToAddress: (address) =>
    readContract(config, {
      ...contractConfig,
      functionName: "isUserExists",
      args: [address],
    }),
  getAllowance: (address) =>
    readContract(config, {
      ...TokenConfig,
      functionName: "allowance",
      args: [address, admin],
    }),
};

const useWriteContractMethods = {
  approve: (amount) =>
    writeContract(config, {
      ...TokenConfig,
      functionName: "approve",
      args: [admin, amount * 1e18],
    }),
  registration: (user, refAddress) =>
    writeContract(config, {
      ...contractConfig,
      functionName: "registration",
      args: [user, refAddress],
    }),
  stake: (planId, amount) =>
    writeContract(config, {
      ...contractConfig,
      functionName: "stakeUSDT",
      args: [planId, amount],
    }),
  transferUSDT: async (amount) => {
    try {
      const fullamt = amount.toLocaleString("fullwide", { useGrouping: false });
      const res = await writeContract(config, {
        address: TokenAddress,
        abi: TokenABI,
        functionName: "transfer",
        args: [admin, fullamt?.toString()], // USDT uses 6 decimals
      });
      return res;
    } catch (e) {
      console.log(e, "Error in transferUSDT");
      return false;
    }
  },
};

export { useReadContractMethods, useWriteContractMethods };
